'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    limitLine((0, _jquery2.default)('.p-l-i__authors', this), 3);
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function limitLine($wrap, lineCount) {
    if (!$wrap) return;

    var $text = $wrap.find("a");
    if (!$text || !$text.css('line-height')) return;

    var lineHeight = parseFloat($text.css('line-height').replace(/[^-\d\.]/g, '') || 0); // need parseFloat here
    var wanaBeHeihgt = Math.ceil(lineHeight * lineCount);

    $wrap.each(function () {
        var $that = (0, _jquery2.default)(this);
        var actualHeight = $that.height();

        if (actualHeight > wanaBeHeihgt) {
            $that.addClass("elipsis-authors");
            $that.addClass("elipsis-element");
            $that.css('max-height', wanaBeHeihgt);
        }
    });
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/dotForManyAuthors.js
// module id = 1066
// module chunks = 1